import { useEffect, useRef, useState } from "react";
import LoadingSpinner from "../../../components/loading-spinner";
import { useLocation } from "react-router-dom";
import { AuthenticationRequest, BrowserInfo, Three3DSResponse } from "../../../models/3ds2.model";
import { decryptService } from "../../../services/decrypt.service";
import { threeDSecure2Service } from "../../../services/3dsecure2.service";
import { CryptedJson } from "./3ds2.types";
import './3ds2-page.scss';


const getChallengeWindowSize = (width: number, height: number): string => {
    const options = [
        { code: '03', w: 500, h: 600 },
        { code: '04', w: 600, h: 400 },
        { code: '02', w: 390, h: 400 },
        { code: '01', w: 250, h: 400 },
    ];

    for (const option of options) {
        if (width >= option.w && height >= option.h) {
            return option.code;
        }
    }

    return '05';
};

const ThreeDS2Page = () => {

    const iframeRef = useRef<HTMLIFrameElement>(null);

    const [isLoading, setIsLoading] = useState(false);

    const [loadingPostback, setLoadingPostBack] = useState(false);

    const [decryptedData, setDecryptedData] = useState<any>();

    const location = useLocation();

    const fullPath = location.pathname;

    const parts = fullPath.split('/');
    const transactionId = parts.slice(2)[0];
    const encryptedData = parts.slice(3).join('/');



    useEffect(() => {
        if (encryptedData) {
            try {

                const decryptedDataJson = decryptService.decryptSensitiveData(encryptedData);

                const dataObject: CryptedJson = JSON.parse(decryptedDataJson);

                console.log(dataObject);


                setDecryptedData(dataObject)

            } catch (e) {
                console.log(e);

            }
        }
    }, [location])


    useEffect(() => {
        const tryAuthentication = async () => {
            try {
                const screenWidth = window.screen.width;
                const screenHeight = window.screen.height;

                const tzOffset = -(new Date().getTimezoneOffset() / 60);

                const browserInfo: BrowserInfo = {
                    browserAcceptHeader: 'application/json',
                    browserJavaEnabled: true,
                    browserLanguage: navigator.language,
                    browserTZ: tzOffset.toString(),
                    browserUserAgent: navigator.userAgent,
                    browserColorDepth: window.screen.colorDepth.toString(),
                    browserScreenHeight: screenHeight.toString(),
                    browserScreenWidth: screenWidth.toString(),
                    browserJavascriptEnabled: true,
                    browserIP: decryptedData.ip,
                    challengeWindowSize: getChallengeWindowSize(screenWidth, screenHeight),
                }


                const authenticationRequest: AuthenticationRequest = {
                    deviceChannel: 'BRW',
                    threeDSCompInd: 'Y',
                    notificationURL: `${decryptedData.internalPostbackUrl}?internalTransactionId=${transactionId}`,
                    browserInfo: browserInfo,
                    requestUrl: decryptedData.responseAuthUrl
                }

                const response = await threeDSecure2Service.sendBrowserDetails(authenticationRequest, decryptedData.apiKey, decryptedData.merchantIdentifier, decryptedData.midName, transactionId)

                if (response.data) {
                    const challengeResponse = await response.data;


                    // const blob = new Blob([html], { type: 'text/html' });
                    // const blobUrl = URL.createObjectURL(blob);

                    if (iframeRef.current && challengeResponse != null) {
                        const formHtml = `
                        <form id="threeDSForm" action="${challengeResponse?.acsUrl}" method="POST">
                            <input type="hidden" name="creq" value="${challengeResponse?.base64EncodedCReq}" />
                        </form>
                        <script>
                            document.getElementById('threeDSForm').submit();
                        </script>`;

                        iframeRef.current.srcdoc = formHtml;
                    }else{
                        window.location.href = decryptedData.redirectUrl;
                    }
                    setIsLoading(false)
                } else {
                    window.location.href = decryptedData.redirectUrl;
                }
            } catch (e) {
                window.location.href = decryptedData.redirectUrl;
            }
        };

        if (decryptedData && transactionId) {
            setIsLoading(true)
            tryAuthentication()
        }

    }, [location, decryptedData, transactionId])

    useEffect(() => {
        const handleMessage = async (event: MessageEvent) => {

            if (event.data?.type === 'postback' && event.data.data === 'COMPLETED') {
                setLoadingPostBack(true)
                try {
                    const response = await threeDSecure2Service.postbackToClient(transactionId, decryptedData.postbackUrl);
                    // window.location.href = decryptedData.redirectUrl;
                } catch (err) {
                    console.error('[Parent] Backend postback failed:', err);
                } finally {
                    setLoadingPostBack(false)
                    window.location.href = decryptedData.redirectUrl;
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [transactionId, decryptedData]);

    return (
        <div className="threeds2-page">
            {/* <iframe src="https://authentication.cardinalcommerce.com" className={`threeds2-iframe ${(isLoading || loadingPostback) ? '' : 'block'}`}
                ref={iframeRef}
            /> */}
            <iframe
                src="https://authentication.cardinalcommerce.com" // actual ACS / 3DS URL
                className={`threeds2-iframe ${(isLoading || loadingPostback) ? '' : 'block'}`}
                ref={iframeRef}
            />
            {(isLoading || loadingPostback) ?
                <div className="loader-container">
                    <span>We're now contacting your bank for 3D Secure authentication. You will be redirected automatically. Please do not close this window.</span>
                </div> : <></>

            }
        </div>
    )
}

export default ThreeDS2Page;